
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import TrialBanner from "@/components/TrialBanner.vue";
import { RouterService } from "@/services";
import store, { ApplicationModule, getStoreModule, RoutesModule, SessionModule } from "@/store";
import { VignetteRoutes } from "@/types";

const applicationStore = getStoreModule(ApplicationModule, store);
const sessionStore = getStoreModule(SessionModule, store);

const appModule = namespace("application");
const sessionModule = namespace("session");
const routesStore = getStoreModule(RoutesModule, store);

@Component({
  components: {
    TrialBanner,
  },
  computed: {
    pageTitle: {
      get(): string {
        return (!sessionStore.isVignetteOnlyUser ? "Vignette - " : "") + applicationStore.getPageName;
      },
    },
    items: () => {
      if (sessionStore.hasVignetteAccess) {
        return sessionStore.isWebUser ? routesStore.getMemberOnlyNavBarRoutes : routesStore.getIPUserOnlyNavBarRoutes;
      } else if (sessionStore.hasLapsedSubscription) {
        return routesStore.getLapsedNavBarRoutes;
      } else if (sessionStore.isLoggedIn && !sessionStore.hasVignetteAccess) {
        return routesStore.getNjMemberNavBarRoutes;
      } else {
        return routesStore.getPublicNavBarRoutes;
      }
    },
    navDrawerExpanded: {
      get() {
        return applicationStore.isNavDrawerExpanded;
      },
      set(isNavDrawerExpanded: boolean) {
        applicationStore.setNavDrawerExpanded(isNavDrawerExpanded);
      },
    },
  },
})
export default class ApplicationHeader extends Vue {
  @appModule.Mutation("setNavDrawerExpanded")
  setNavDrawerExpanded!: (expanded: boolean) => void;

  @sessionModule.Getter("isLoggedIn")
  isLoggedIn!: () => boolean;

  @sessionModule.Getter("isVignetteOnlyUser")
  isVignetteOnly!: () => boolean;

  @sessionModule.Action("login")
  login!: () => void;

  @sessionModule.Action("logout")
  logout!: () => void;

  get isNjLogoDisplayed(): boolean {
    return sessionStore.isLoggedIn && !sessionStore.isVignetteOnlyUser;
  }

  get isTrialUser(): boolean {
    return sessionStore.isTrialUser;
  }

  get hasVignetteAccess(): boolean {
    return sessionStore.hasVignetteAccess;
  }

  get currentDate(): string {
    return new Date()
      .toLocaleDateString("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" })
      .toUpperCase();
  }

  get facebookUrl(): string {
    return "https://www.facebook.com/NationalJournal/";
  }

  get twitterUrl(): string {
    return "https://twitter.com/nationaljournal";
  }

  get linkedInUrl(): string {
    return "https://www.linkedin.com/company/9313";
  }

  navigateToHomePage(): void {
    if (this.isNjLogoDisplayed) {
      window.location.href = applicationStore.getBaseUrlOrigin;
    } else {
      RouterService.navigateToHome(this.$router);
    }
  }

  navigateToMyAccountPage(): void {
    if (!sessionStore.isVignetteOnlyUser) {
      window.location.href = "/my-account/";
    } else {
      RouterService.navigateByName(this.$router, VignetteRoutes.MyAccount);
    }
  }

  navigateToSearchPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.Search, {});
  }

  navigateToBriefcasePage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.Briefcase);
  }

  navigateToLoginPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.LoginRedirect);
  }

  navigateToSignUpPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.SignUp);
  }

  navigateToFaqPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.Faq);
  }

  navigateToContactPage(): void {
    RouterService.navigateByName(this.$router, VignetteRoutes.Contact);
  }
}
